import Empty from 'constants/empty';

const headerAndFooterSelector = store => store.headerAndFooter || Empty.Object;

export { headerAndFooterSelector };
